module.exports = __webpack_public_path__ + "img/selectgoods.7b4794ae.png";